import { getCookie, setCookie } from './utils.js';

const COOKIE_CONSENT_KEY = 'cookie_consent';
const COOKIE_DAYS = 365;

let consentChangeCallbacks = [];

export function onConsentChange(callback) {
  consentChangeCallbacks.push(callback);
}

function notifyConsentChange(consent) {
  consentChangeCallbacks.forEach(cb => cb(consent));
}

export function getConsent() {
  const raw = getCookie(COOKIE_CONSENT_KEY);
  if (!raw) return null;
  try {
    const prefs = JSON.parse(decodeURIComponent(raw));
    return {
      necessary: prefs.necessary !== false,
      analytics: !!prefs.analytics,
      marketing: !!prefs.marketing
    };
  } catch {
    return null;
  }
}

export function setConsent(prefs) {
  const normalized = {
    necessary: prefs.necessary !== false,
    analytics: !!prefs.analytics,
    marketing: !!prefs.marketing
  };
  setCookie(COOKIE_CONSENT_KEY, encodeURIComponent(JSON.stringify(normalized)), COOKIE_DAYS);
  notifyConsentChange(normalized);
}

function getBanner() {
  return document.querySelector('.cookies-banner');
}

function getManageWrapper() {
  return document.querySelector('.manage-cookies-wrapper');
}

function showBanner() {
  const banner = getBanner();
  if (banner) {
    banner.classList.remove('cookies-banner--hidden');
    banner.setAttribute('aria-hidden', 'false');
  }
}

function hideBanner() {
  const banner = getBanner();
  if (banner) {
    banner.classList.add('cookies-banner--hidden');
    banner.setAttribute('aria-hidden', 'true');
  }
}

function showManagePopup() {
  const wrapper = getManageWrapper();
  if (wrapper) {
    wrapper.classList.remove('manage-cookies-wrapper--hidden');
    wrapper.setAttribute('aria-hidden', 'false');
    applyConsentToCheckboxes();
  }
}

function hideManagePopup() {
  const wrapper = getManageWrapper();
  if (wrapper) {
    wrapper.classList.add('manage-cookies-wrapper--hidden');
    wrapper.setAttribute('aria-hidden', 'true');
  }
}

function applyConsentToCheckboxes() {
  const consent = getConsent();
  const analyticsEl = document.getElementById('manage-cookies-analytics');
  const marketingEl = document.getElementById('manage-cookies-marketing');
  if (analyticsEl) analyticsEl.checked = consent ? consent.analytics : false;
  if (marketingEl) marketingEl.checked = consent ? consent.marketing : false;
}

function saveFromCheckboxesAndClose() {
  const analyticsEl = document.getElementById('manage-cookies-analytics');
  const marketingEl = document.getElementById('manage-cookies-marketing');
  setConsent({
    necessary: true,
    analytics: analyticsEl ? analyticsEl.checked : false,
    marketing: marketingEl ? marketingEl.checked : false
  });
  hideManagePopup();
}

export function initCookiesConsent() {
  const banner = getBanner();
  const wrapper = getManageWrapper();
  if (!banner && !wrapper) return;

  let openedWithoutConsent = false;

  if (!getConsent()) {
    requestAnimationFrame(() => {
      showBanner();
    });
  }

  const acceptAllButtons = document.querySelectorAll('.cookies-banner__button--accept-all');
  acceptAllButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      setConsent({ necessary: true, analytics: true, marketing: true });
      hideBanner();
    });
  });

  const rejectButtons = document.querySelectorAll('.cookies-banner__button--reject');
  rejectButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      setConsent({ necessary: true, analytics: false, marketing: false });
      hideBanner();
    });
  });

  const manageButtons = document.querySelectorAll('.cookies-banner__button--manage');
  manageButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      openedWithoutConsent = !getConsent();
      hideBanner();
      showManagePopup();
    });
  });

  const doneButton = document.querySelector('.manage-cookies__button--done');
  if (doneButton) {
    doneButton.addEventListener('click', () => {
      saveFromCheckboxesAndClose();
    });
  }

  if (wrapper) {
    wrapper.addEventListener('click', (e) => {
      if (e.target === wrapper) {
        hideManagePopup();
        if (openedWithoutConsent) showBanner();
      }
    });
  }
}
